
import { throwError as observableThrowError } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { share } from 'rxjs/operators';
import { IAppConfig } from '@app/_shared/_models';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private readonly http = inject(HttpClient);
  public config: IAppConfig | undefined = undefined;

  // This is the method you want to call at bootstrap
  // Important: It should return a Promise
  async load(): Promise<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return new Promise((resolve, reject) => {
      this.http.get('assets/configs/app.config.json', options)
        .pipe(
          share()
        )
        .subscribe((configResponse: any) => {
          this.config = configResponse;
          console.log('App config loaded successfully.');
          resolve(true);
        }, (error: any) => {
          console.error('Unable to read App Configuration json file.');
          resolve(true);

          return observableThrowError(error || 'Server error');
        });
    });
  }
}
